import {
  Dialog,
  IconButton,
  Typography,
  Slide,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import CloseIcon from "../CreateDataTable/icons/CloseIcon";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "right",
  },
  container: {
    width: "95%",
  },
}));

const DataTableDialogWrapper = ({
  open,
  onClose,
  title,
  description,
  sidebarMenu,
  children,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      classes={{
        root: classes.root,
        container: classes.container,
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          background: "#FFFFFF",
        }}
      >
        {/* left side of the dialog  */}
        <div
          style={{
            width: "81%",
          }}
        >
          <div style={{ padding: "20px 0 20px 32px" }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
              size="medium"
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div style={{ paddingLeft: "80px", paddingRight: "80px" }}>
            {/* title and subtitle section */}
            <div
              style={{ display: "grid", gap: "15px", paddingBottom: "15px" }}
            >
              <Typography
                gutterBottom
                style={{
                  fontFamily: " Avenir",
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#292929",
                }}
              >
                {title}
              </Typography>
              <Typography
                gutterBottom
                style={{
                  fontFamily: " Avenir",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#858585",
                }}
              >
                {description}
              </Typography>
            </div>

            {/* Render table */}
            {children}
          </div>
        </div>

        {/* right side of the dialog  */}
        <div
          style={{
            borderLeft: "1px solid #F0F0F0",
            width: "19%",
          }}
        >
          {/* Render menu options */}
          {sidebarMenu}
        </div>
      </div>
    </Dialog>
  );
};

export default DataTableDialogWrapper;
